<template>
  <ui-file v-bind="config" @change="onFileSelected">
    <ui-button outlined icon="file_upload">{{ buttonText }}</ui-button>
  </ui-file>
</template>
<script>
export default {
  name: 'file',
  model: {
    prop: 'file',
    event: 'change'
  },
  props: {
    maxFileSize: {
      type: Number,
      default: 10 * 1024 * 1024 // 默认10MB
    },
    file: {
      type: null,
      default: null
    },
    title: {
      type: String,
      default: '文件'
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    buttonText() {
      return this.file ? this.file.name : `上传${this.title}`;
    }
  },
  methods: {
    onFileSelected([file]) {
      const { sourceFile, size } = file;
      if (size > this.maxFileSize) {
        this.$toast(`文件大小不能超过 ${this.maxFileSize / 1024 / 1024}MB`);
        return;
      }
      this.$emit('change', sourceFile);
    }
  }
};
</script>
